<template>
  <b-modal
    id="modal-filter3"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    title="過瀘"
    headerClass="pr-3 py-2 border-bottom bgWhite"
    footerClass="px-3 py-2 border-top bgWhite"
    hide-footer
    no-close-on-backdrop
    size="lg"
  >
   
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="客戶："
              label-for="filter_customer_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_customer_id"
                v-model="update.filter_customer_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="customerOptions"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇客戶"
                :filter="customerSearch"
              >
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="發票："
              label-for="filter_invoice_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_invoice_id"
                v-model="update.filter_invoice_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="invoiceOptions"
                label="invoice_number"
                :reduce="(option) => option.id"
                placeholder="選擇發票"
                :filter="invoiceSearch"
              >
                <template #option="{ invoice_number, project_name, quotation_number }">
                  {{ invoice_number }} {{ project_name }} {{ quotation_number }}
                </template>
                <template #selected-option="{ invoice_number, project_name, quotation_number }">
                  {{ invoice_number }} {{ project_name }} {{ quotation_number }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="狀態："
              label-for="filter_voucher_status_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_voucher_status_id"
                v-model="update.filter_voucher_status_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="voucherStatusOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇狀態"
              ></v-select>
            </b-form-group>
          </b-col>
        
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="update = {}"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-filter3");
    },
    onSubmit() {
      this.$emit(
        "update:filter_invoice_id",
        this.update.filter_invoice_id
      );
      this.$emit("update:filter_customer_id", this.update.filter_customer_id);
      this.$emit("update:filter_voucher_status_id", this.update.filter_voucher_status_id);
      this.hide();
    },
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.customer_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    invoiceSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.invoice_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
  },
  props: {
    invoiceOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    voucherStatusOptions: {
      type: Array,
      required: true,
    },
    filter_invoice_id: {},
    filter_customer_id: {},
    filter_voucher_status_id: {},
  },
  data() {
    return {
      loading: false,
      update: {
        filter_invoice_id: null,
        filter_customer_id: null,
        filter_voucher_status_id: null,
      },
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
